import clsx from 'clsx';
import { type InterfaceAppearanceDto } from '@/app/models/InterfaceAppearanceDto';
import SafeImage from '@/app/modules/widgets/SafeImage';
import { useInterfaceAppearance } from './useInterfaceAppearance';
import './SystemLogo.css';

type SystemLogoProps = {
  className?: string;
  showName?: boolean;
  appearance?: InterfaceAppearanceDto;
};

export const SystemLogo = ({ className, showName = true, appearance: previewAppearance }: SystemLogoProps) => {
  const { appearance: savedAppearance } = useInterfaceAppearance();
  const appearance = previewAppearance ?? savedAppearance;
  const systemName = appearance.system_name;
  const defaultLogo = '/media/logos/easypdv-logo-dark.svg';
  const logoSource = appearance.logo?.public_url || defaultLogo;
  const isDefaultLogo = !appearance.logo?.public_url;
  const imageAlt = showName ? '' : systemName;
  const imageMaxWidth = showName ? '70px' : '100%';

  return (
    <span className={clsx('system-logo', className)} title={systemName}>
      <span className="d-flex align-items-center gap-3 h-100" style={{ minWidth: 0 }}>
        <SafeImage
          alt={imageAlt}
          className={clsx('h-100 object-fit-contain', { 'system-logo-default-image': isDefaultLogo })}
          fallbackSrc={defaultLogo}
          src={logoSource}
          style={{ maxWidth: imageMaxWidth, minWidth: 0 }}
        />
        {showName ? <span className="system-logo-name fw-bold fs-5 text-truncate">{systemName}</span> : null}
      </span>
    </span>
  );
};
